module.exports = __webpack_public_path__ + "img/casa-parochial.727af85e.jpg";